import { Honeybadger } from '@honeybadger-io/react';

import {
  getRuntimeConfig,
  PublicRuntimeConfig,
} from '@catawiki/next-config/runtime-config';
import { Cookie, Observability } from '@catawiki/runtime-toolkit';

import { getUserId } from '@/shared/helpers/cookies';
import { isRelevantError } from '@/shared/utils/reporting';

export enum ErrorTag {
  warning = 'warning',
}

let configuredHoneybadgerSignature: string | undefined;

export function configureHoneybadger(
  runtimeConfig: PublicRuntimeConfig = getRuntimeConfig()
): void {
  if (!runtimeConfig.honeybadgerApiKey || !runtimeConfig.stage) {
    return;
  }

  const signature = [
    runtimeConfig.honeybadgerApiKey,
    runtimeConfig.stage,
    runtimeConfig.lastCommitSha ?? '',
  ].join('|');

  if (configuredHoneybadgerSignature === signature) {
    return;
  }

  Honeybadger.configure({
    apiKey: runtimeConfig.honeybadgerApiKey,
    environment: runtimeConfig.stage,
    revision: runtimeConfig.lastCommitSha,
    projectRoot: 'webpack://_N_E/./',
    developmentEnvironments: ['development', 'staging', 'test'],
  });

  if (typeof window !== 'undefined') {
    Honeybadger.setContext({
      user_id: getUserId(),
      platform: Cookie.getIsMobileApp() ? 'app' : 'web',
    });
  }

  Honeybadger.beforeNotify(isRelevantError);

  configuredHoneybadgerSignature = signature;
}

export function report(
  error: Error,
  options: NonNullable<Parameters<typeof Honeybadger.notify>[2]>
): void {
  Observability.notifyHB(error, { ...options, fingerprint: error.name });
  console.error(options, error);
}
